import React from 'react';
import { Box, Flex, Heading, Text, VStack, HStack, Icon } from '@chakra-ui/react';
import { FaMapMarkerAlt } from 'react-icons/fa';

const Experience = () => {
  const experiences = [
    {
      title: 'Frontend Developer Intern',
      company: 'HyperNorm.ai',
      duration: '09/2024 – 11/2024',
      location: 'Bengaluru, India',
      responsibilities: [
        'Design and implement responsive, user-friendly pages to enhance usability.',
        'Manage state efficiently using Redux Toolkit.',
        'Ensure consistent styling with modular SCSS.',
        'Collaborate with backend developers for seamless functionality.'
      ],
      techStack: ['React.js', 'SCSS', 'Redux Toolkit']
    },
    // {
    //   title: 'Assessment-Assistantship',
    //   company: 'Masai',
    //   duration: '10/2023 – 03/2024',
    //   location: 'Bengaluru'
    // },
    {
      title: 'Data Analyst (Medical Billing)',
      company: 'IKS Health Pvt. Ltd',
      duration: '11/2021 – 11/2022',
      responsibilities: [
        'Processed patient and insurance refunds.',
        'Implemented accurate payment posting procedures.',
        'Handled client emails.'
      ],
      location: 'Hyderabad'
    }
  ];

  return (
    <div id="experiance"  className="experiance section">

  
    <Box py={10} px={5} maxW="6xl" mx="auto">
      <Heading
        textAlign="center"
        fontSize={{ base: '2xl', md: '4xl' }}
        py={5}
        fontWeight="bold">
        Experience
      </Heading>

      <VStack spacing={8} align="stretch">
        {experiences.map((exp, index) => (
          <Box
            key={index}
            p={5}
            borderWidth={1}
            borderRadius="md"
            boxShadow="md"
            _hover={{ boxShadow: 'lg' }}>
            <Flex justify="space-between" align="center" mb={2}>
              <Heading fontSize="xl" fontWeight="semibold">
                {exp.title}
              </Heading>
              <Text fontSize="sm" color="gray.500">
                {exp.duration}
              </Text>
            </Flex>

            <Text fontWeight="medium" color="teal.500" mb={1}>
              {exp.company}
            </Text>

            <HStack spacing={2} color="gray.600" mb={4}>
              <Icon as={FaMapMarkerAlt} />
              <Text>{exp.location}</Text>
            </HStack>

            {exp.responsibilities && (
              <VStack align="start" spacing={2} mb={3}>
                {exp.responsibilities.map((item, i) => (
                  <Text key={i} fontSize="sm" color="gray.700">
                    • {item}
                  </Text>
                ))}
              </VStack>
            )}

            {exp.techStack && (
              <Text fontSize="sm" fontWeight="medium" color="gray.800">
                <strong>Tech Stack:</strong> {exp.techStack.join(' | ')}
              </Text>
            )}
          </Box>
        ))}
      </VStack>
    </Box>
    </div>
  );
};

export default Experience;
